module.exports = __webpack_public_path__ + "static/media/feeling-neutral.8fb67c2f.svg";